var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.92V11.23C10 12.25 10.83 13.08 11.85 13.08H21C21.55 13.08 22 12.63 22 12.08V5.69C22 3.65 20.35 2 18.31 2H10.93C10.41 2 10 2.41 10 2.92Z",
    fill: "#0061AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5C2.22 15.5 2 15.72 2 16V17C2 18.66 3.34 20 5 20C5 18.35 6.35 17 8 17C9.65 17 11 18.35 11 20H13C13 18.35 14.35 17 16 17C17.65 17 19 18.35 19 20C20.66 20 22 18.66 22 17V15C22 14.45 21.55 14 21 14H11.5C10.837 14 10.2011 13.7366 9.73223 13.2678C9.26339 12.7989 9 12.163 9 11.5V6C9 5.45 8.55 5 8 5H7.16C6.44 5 5.78 5.39 5.42 6.01L4.78 7.13C4.69 7.29 4.81 7.5 5 7.5C5.66304 7.5 6.29893 7.76339 6.76777 8.23223C7.23661 8.70107 7.5 9.33696 7.5 10V13C7.5 13.663 7.23661 14.2989 6.76777 14.7678C6.29893 15.2366 5.66304 15.5 5 15.5H2.5Z",
    fill: "#0061AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22C15.4696 22 14.9609 21.7893 14.5858 21.4142C14.2107 21.0391 14 20.5304 14 20C14 19.4696 14.2107 18.9609 14.5858 18.5858C14.9609 18.2107 15.4696 18 16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 20.5304 17.7893 21.0391 17.4142 21.4142C17.0391 21.7893 16.5304 22 16 22ZM8 22C7.46957 22 6.96086 21.7893 6.58579 21.4142C6.21071 21.0391 6 20.5304 6 20C6 19.4696 6.21071 18.9609 6.58579 18.5858C6.96086 18.2107 7.46957 18 8 18C8.53043 18 9.03914 18.2107 9.41421 18.5858C9.78929 18.9609 10 19.4696 10 20C10 20.5304 9.78929 21.0391 9.41421 21.4142C9.03914 21.7893 8.53043 22 8 22ZM2 12.53V14H5C5.55 14 6 13.55 6 13V10C6 9.45 5.55 9 5 9H3.71L2.26 11.54C2.09 11.84 2 12.18 2 12.53Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.e7f991ae9d24332ca7e08acf69d4ac20.svg";
export { ForwardRef as ReactComponent };